import React from "react";
import { Box, Card } from "@curves/ui-base";
import { isEqual } from "@util/utils";
import { CYCLEORDER_TYPE } from "@icoach/constants/";
import { Grid } from "@mui/material";
import { ReadTextField } from "@icoach/components";
import {
	TerminateSectionByRead,
	ConsumerSectionByRead,
	ProductSectionByRead,
	ReceiverSectionByRead,
	PaymentSectionByRead,
	InvoiceSectionByRead,
	SuspensionSectionByRead,
} from "@icoach/healthyCyclePurchase/components";

const CyclePurchaseDetailOrder = ({ sourceData = {} }) => {
	const { cycleOrderType } = sourceData;
	return (
		<Box>
			{/* 暫停資訊 */}
			{isEqual(cycleOrderType, CYCLEORDER_TYPE.PAUSEORDER) ? (
				<Card className="order-info-card mb-4">
					<SuspensionSectionByRead titleClassName="px-4 bg-error-light" sourceData={sourceData} />
				</Card>
			) : null}

			{/* 退訂資訊 */}
			{isEqual(cycleOrderType, CYCLEORDER_TYPE.UNSUBSCRIBEORDER) ? (
				<Card className="order-info-card mb-4">
					<TerminateSectionByRead titleClassName="px-4 bg-error-light" sourceData={sourceData} />
				</Card>
			) : null}
			<Card className="order-info-card mb-4">
				{/* 訂購人資訊 */}
				<ConsumerSectionByRead sourceData={sourceData} />

				{/* 訂購商品 */}
				<ProductSectionByRead sourceData={sourceData} />

				{/* 收件人資訊 */}
				<ReceiverSectionByRead sourceData={sourceData} />

				{/* 付款資訊 */}
				<PaymentSectionByRead sourceData={sourceData} />

				{/* 發票資訊 */}
				<InvoiceSectionByRead sourceData={sourceData} />
			</Card>
			<Card className="order-info-card">
				{/* 店舖教練資訊 */}
				<Card.CardHeader title="店舖教練資訊" className="bg-light-active px-4" />
				<Card.CardContent className="p-4">
					<Grid spacing={3} container>
						<Grid xs={4} item>
							<ReadTextField label="所屬店舖">{sourceData?.clubName ?? ""}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="販售店舖">{sourceData?.saleClubName ?? ""}</ReadTextField>
						</Grid>
						<Grid xs={4} item>
							<ReadTextField label="擔當">{sourceData?.employeeName ?? ""}</ReadTextField>
						</Grid>
					</Grid>
				</Card.CardContent>
			</Card>
		</Box>
	);
};

export default CyclePurchaseDetailOrder;
